module.exports = __webpack_public_path__ + "img/ic-dt-point.bc1f9cc5.png";